module.exports = __webpack_public_path__ + "media/images/icon/icons8-Add to Favorites-ad3aa8ed007876174e805907e9c1937b.png";